/** @namespace Bodypwa/Component/ProductCardImage/Config */

export const INTERSECTION_THRESHOLD = 0.6;
export const TEASE_START_DELAY_MS = 250;
export const TEASE_END_DELAY_MS = 900;
export const SLIDE_THRESHOLD_PX = 30;
export const SLIDE_TRANSLATE_PCT = 100;
export const TEASE_OFFSET_PCT = 50;
export const MIN_SWIPE_PX = 5;
export const LINK_TAB_INDEX = -1;
